import { decodeAndGet } from '../../utils'
import { outletDecoder } from '../decoders'
import type { OutletDescription } from '../types'
import { api } from './api'

export const outletApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOutlet: build.query<OutletDescription, void>({
      query: () => ({
        url: '/arm/corner/outlet',
        method: 'POST',
        body: {},
      }),
      transformResponse: (response: unknown) => {
        const [data, error] = decodeAndGet(outletDecoder, response)
        if (error) throw new Error(error)
        return data!
      },
      providesTags: ['Outlet'],
    }),
    toggleOutletAvailability: build.mutation<void, void>({
      query: () => ({
        url: '/arm/corner/enabled/outlet',
        method: 'POST',
        body: {},
      }),
      invalidatesTags: ['Outlet'],
    }),
  }),
})
